import { render, staticRenderFns } from "./Manifest.vue?vue&type=template&id=3dba35ed&scoped=true&"
import script from "./Manifest.vue?vue&type=script&lang=ts&"
export * from "./Manifest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dba35ed",
  null
  
)

export default component.exports